import React, { useState } from 'react';
import { FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { downloadFaceSheet } from './FaceSheetButton';

const wait = (ms) => new Promise(r => setTimeout(r, ms));

// Downloads one pre-filled Face Sheet per selected patient
export const BatchFaceSheets = ({ patients, onDone }) => {
  const [progress, setProgress] = useState(null);
  const run = async () => {
    let ok = 0;
    for (let i = 0; i < patients.length; i++) {
      setProgress(i + 1);
      try { await downloadFaceSheet(patients[i]); ok += 1; } catch { /* reported below */ }
      await wait(450);
    }
    setProgress(null);
    if (ok === patients.length) toast.success(`${ok} Face Sheets downloaded`);
    else toast.error(`${ok} of ${patients.length} Face Sheets downloaded`);
    onDone();
  };
  if (!patients.length) return null;
  return (
    <button onClick={run} disabled={progress != null} data-testid="batch-facesheet-btn"
      className="px-3 py-1.5 bg-[#1e40af] text-white rounded text-sm hover:bg-[#1e3a8a] flex items-center gap-2 disabled:opacity-60">
      {progress != null ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
      {progress != null ? `Creating ${progress} of ${patients.length}…` : `Download ${patients.length} Face Sheet${patients.length > 1 ? 's' : ''}`}
    </button>
  );
};
